import {cn} from '@rocket-ui/tools';
import React, {DetailedHTMLProps, InputHTMLAttributes} from 'react';

export type NewInputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const NewInput = React.forwardRef<HTMLInputElement, NewInputProps>(function NewInput(
	{className, ...props},
	ref,
) {
	return (
		<input
			className={cn(
				'border-none bg-transparent h-14 m-0 p-0 text-sm focus:text-sm placeholder:text-skin-placeholder',
				className,
			)}
			{...props}
			ref={ref}
		/>
	);
});
